/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wtballoon__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wtmessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_animationFrame__ = __webpack_require__(10);
/* globals window document Image localStorage */




var WTGM = {
  // set up some inital values
  WIDTH: 320,
  HEIGHT: 480,
  scale: 1,
  // the position of the canvas
  // in relation to the screen
  offset: { top: 0, left: 0 },
  paused: 1,
  score: 0,
  highsore: 0,
  highscoreBroken: 0,
  mode: 3,
  life: 2,
  lastPos: -1,
  lastScore: -1,
  // The question
  // question : "2 + _ = 5",
  // The answers
  // answers : [ 2, 3, 5 ],
  // rightAnswer : 1,
  message: [],
  // Tile map matrix->Level
  objects: [], // : g_level1_1,
  createObjectTime: 0,
  //  texture
  tex: new Image(),
  texSrc: './img/sprite.png',
  back: new Image(),
  backSrc: './img/back.png',
  showFps: 0,
  fps: 0,
  lastFrame: 0,
  touching: 0,
  touchHit: 0,
  touchStart: 0,
  touchX: 0,
  touchY: 0,
  baby: 0,

  // Zoom helper, 3 zoom levels supported
  zoomHelper: {
    level: 1,
    NORMAL: 1,
    FAR: 0.50,
    CLOSE: 2
  },
  // Scroll position helper, keeps track of scrolling
  scrollPosition: { x: 0, y: 0 },
  // Tile texture
  tile: null,

  // Grid dimensions
  grid: {
    width: 15,
    height: 10
  },

  // we'll set the rest of these
  // in the init function
  RATIO: null,
  currentWidth: null,
  currentHeight: null,
  canvas: null,
  ctx: null,
  keys: {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    W: 87,
    A: 65,
    S: 83,
    D: 68,
    Z: 90,
    X: 88,
    R: 82
  },

  init: function init(preloadResources) {
    // the proportion of width to height
    WTGM.RATIO = WTGM.WIDTH / WTGM.HEIGHT;
    // these will change when the screen is resize
    WTGM.currentWidth = WTGM.WIDTH;
    WTGM.currentHeight = WTGM.HEIGHT;
    // WTGM is our canvas element
    WTGM.canvas = document.getElementsByTagName('canvas')[0];
    // it's important to set WTGM
    // otherwise the browser will
    // default to 320x200
    WTGM.canvas.width = WTGM.WIDTH;
    WTGM.canvas.height = WTGM.HEIGHT;
    // the canvas context allows us to
    // interact with the canvas api
    WTGM.ctx = WTGM.canvas.getContext('2d');

    /* Preload!! */
    preloadResources(WTGM.canvas, function () {
      WTGM.tex.src = WTGM.texSrc;
      WTGM.back.src = WTGM.backSrc;
      // Set Up tiles
      // WTGM.tile = new Image();
      // WTGM.tile.src = "res/img/tile32x32.png";
      // WTGM.tile.width *= WTGM.zoomHelper.level;
      // WTGM.tile.height *= WTGM.zoomHelper.level;

      WTGM.resize(); // we're ready to resize


      // WTGM.generateBalloon();

      WTGM.loop();
    });
  },
  resize: function resize() {
    WTGM.currentHeight = window.innerHeight;

    // resize the width in proportion
    // to the new height
    WTGM.currentWidth = WTGM.currentHeight * WTGM.RATIO;

    // set the new canvas style width & height
    // note: our canvas is still 320x480 but
    // we're essentially scaling it with CSS
    WTGM.canvas.style.width = WTGM.currentWidth + 'px';
    WTGM.canvas.style.height = WTGM.currentHeight + 'px';

    // the amount by which the css resized canvas
    // is different to the actual (480x320) size.
    WTGM.scale = WTGM.currentWidth / WTGM.WIDTH;
    // position of canvas in relation to
    // the screen
    WTGM.offset.top = WTGM.canvas.offsetTop;
    WTGM.offset.left = WTGM.canvas.offsetLeft;

    // we use a timeout here as some mobile
    // browsers won't scroll if there is not
    // a small delay
    window.setTimeout(function () {
      window.scrollTo(0, 1);
    }, 1);
  },


  // handleMouseDown(x, y) {

  // },

  translatePixels: function translatePixels(x, y) {
    this.x = (x - WTGM.offset.left) / WTGM.scale;
    this.y = (y - WTGM.offset.top) / WTGM.scale;

    return {
      x: this.x,
      y: this.y
    };
  },


  /**
   * Touch and Mouse-Click
   *
   * @param {any} x
   * @param {any} y
   */
  handleTouch: function handleTouch(x, y) {
    // var hit = 0;
    var pos = WTGM.translatePixels(x, y);
    var time = new Date().getTime();
    var addScore = 0;
    WTGM.touchX = pos.x;
    WTGM.touchY = pos.y;
    if (time - WTGM.touchStart > 300) {
      // Zeit um Bonus zu bekommen ist vorbei!
      WTGM.touchStart = time;
      WTGM.hit = 0;
    }
    // Hit?
    if (WTGM.touching) {
      // [].re
      WTGM.objects = WTGM.objects.reduce(function (newObjects, object) {
        var newObject = Object.assign({}, object);
        if (newObject.isInside(pos.x, pos.y)) {
          // if (time - WTGM.touchStart <= 300) {
          // Zeit um Bonus zu bekommen!
          WTGM.hit += 1;
          // } else {
          //   WTGM.hit = 1;
          // }
          addScore = newObject.score * WTGM.hit;
          WTGM.score += addScore;
          newObject.remove = true;
          if (WTGM.hit > 1) {
            var message = new __WEBPACK_IMPORTED_MODULE_1__wtmessage__["a" /* default */]('+' + Math.round(addScore / 100) + '(x' + WTGM.hit + ')', pos.x, pos.y, '#118811', WTGM);
            newObjects.push(message);
          } else {
            var _message = new __WEBPACK_IMPORTED_MODULE_1__wtmessage__["a" /* default */]('+' + Math.round(addScore / 100), pos.x, pos.y, '#118811', WTGM);
            newObjects.push(_message);
          }
        }
        newObjects.push(newObject);
        return newObjects;
      }, []);

      if (!WTGM.highscoreBroken && Math.round(WTGM.score / 100) > WTGM.highsore) {
        var message = new __WEBPACK_IMPORTED_MODULE_1__wtmessage__["a" /* default */]('HIGHSCORE!', WTGM.touchX, WTGM.touchY - 25, '#118811', WTGM);
        WTGM.objects.push(message);
        WTGM.highscoreBroken = 1;
      }
    }
  },
  handleTouchEnd: function handleTouchEnd() {
    if (WTGM.touching && !WTGM.paused) {
      if (!WTGM.hit) {
        // var pos = WTGM.translatePixels(x,y);
        if (WTGM.score - 1000 > 0) {
          WTGM.score -= 1000;
          var message = new __WEBPACK_IMPORTED_MODULE_1__wtmessage__["a" /* default */]('-10', WTGM.touchX, WTGM.touchY, '#881111', WTGM);
          WTGM.objects.push(message);
          if (WTGM.highscoreBroken && Math.round(WTGM.score / 100) < WTGM.highsore) {
            message = new __WEBPACK_IMPORTED_MODULE_1__wtmessage__["a" /* default */]('Highscore lost!', WTGM.touchX, WTGM.touchY - 25, '#881111', WTGM);
            WTGM.objects.push(message);
            WTGM.highscoreBroken = 0;
          }
        }
      }
      WTGM.hit = 0;
      WTGM.touchStart = 0;
      WTGM.touching = 0;
    }
  },
  startGame: function startGame() {
    WTGM.message = [];
    WTGM.createObjectTime = 0;
    WTGM.objects = [];
    WTGM.score = 0;
    WTGM.life = 2 * WTGM.mode;
    WTGM.paused = 0;

    WTGM.highsore = localStorage.getItem(1);
  },
  endGame: function endGame() {
    WTGM.paused = 1;
    document.querySelector('.startGame').textContent = 'Play';
    document.querySelector('.inGameOption').style.display = 'none';
    document.querySelector('.ui').classList.remove('gameRunning');
    document.querySelector('.ui').style.display = '';
    document.querySelector('.openMenu').style.display = 'none';

    WTGM.setScore();
  },
  setScore: function setScore() {
    WTGM.lastPos = -1;
    WTGM.lastScore = Math.round(WTGM.score / 100);
    var oldScores = [];
    var scores = [];
    var found = false;
    // Scores auslesen:
    for (var i = 0; i < 10; i += 1) {
      oldScores[i] = localStorage.getItem(i + 1);
    }
    // Aktuelle Punkte eintragen:
    // Wenn unser Score Highscore ist, kann es 11 Einträge geben, nur 10 werden gespeichert!
    for (var _i = 0; _i < 11; _i += 1) {
      if (!found) {
        if (WTGM.lastScore > oldScores[_i] || oldScores[_i] === 'null') {
          scores[_i] = WTGM.lastScore;
          found = true;
          WTGM.lastPos = _i;
        } else {
          scores[_i] = oldScores[_i];
        }
      } else {
        scores[_i] = oldScores[_i - 1];
      }
    }
    // Scores eintragen:
    for (var _i2 = 0; _i2 < 10; _i2 += 1) {
      localStorage.setItem(_i2 + 1, scores[_i2]);
    }
  },


  // WTGM is where all entities will be moved
  // and checked for collisions etc
  update: function update() {
    if (WTGM.life <= 0) {
      WTGM.endGame();
    }
    WTGM.generateBalloon();

    // update objects
    WTGM.objects.forEach(function (object) {
      object.update();
    });
    // remove
    WTGM.objects = WTGM.objects.filter(function (object) {
      return !object.remove;
    });
  },


  // WTGM is where we draw all the entities
  render: function render() {
    WTGM.ctx.clearRect(0, 0, WTGM.canvas.width, WTGM.canvas.height);
    WTGM.ctx.fillStyle = '#2222dd'; // '#7c4f22';
    WTGM.ctx.fillRect(0, 0, WTGM.canvas.width, WTGM.canvas.height);
    WTGM.ctx.drawImage(WTGM.back, 0, 0);
    // Objects
    for (var i = 0; i < WTGM.objects.length; i += 1) {
      WTGM.objects[i].draw(WTGM.ctx);
    }
    // Score
    WTGM.Draw.text('Points: ' + Math.round(WTGM.score / 100), 5, 25, 24, '#333');
    WTGM.Draw.text('Life: ' + WTGM.life, 5, 50, 24, '#333');
    // FPS
    if (WTGM.showFps) {
      WTGM.Draw.text(Math.round(WTGM.fps), 5, 440, 24, '#333');
    }
  },


  /**
   * the actual loop
   * requests animation frame
   * then proceeds to update and render
   */
  loop: function loop() {
    // order new loop
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_animationFrame__["a" /* default */])(WTGM.loop);

    if (!WTGM.paused) {
      WTGM.update();
      WTGM.render();
    }

    if (WTGM.showFps) {
      if (!WTGM.lastFrame) {
        WTGM.lastFrame = new Date().getTime();
        WTGM.fps = 0;
      }
      var time = new Date().getTime();
      var delta = (time - WTGM.lastFrame) / 1000;
      WTGM.lastFrame = time;
      WTGM.fps = 1 / delta;
    }
  },


  /**
   * Generate a random balloon
   *
   */
  generateBalloon: function generateBalloon() {
    var time = new Date().getTime();
    // if (WTGM.createObjectTime <= time) {
    //   WTGM.createObjectTime = time + Math.floor(Math.random() * 2000) + 500;
    //   const balloon = new WtBalloon(Math.floor(Math.random() * 8),
    //     Math.floor(Math.random() * 256), 500, Math.floor(Math.random() * 3) + 1, WTGM);
    //   WTGM.objects.push(balloon);
    // }

    var balloonCreateRand = 2000;
    var balloonCreateConst = 500;
    var balloonSpeedRand = 3;
    var balloonSpeedConst = 1;

    if (WTGM.baby) {
      balloonCreateRand = 3000;
      balloonCreateConst = 1000;
      balloonSpeedRand = 1;
    }
    if (WTGM.createObjectTime <= time) {
      WTGM.createObjectTime = time + Math.floor(Math.random() * balloonCreateRand) + balloonCreateConst;
      var balloon = new __WEBPACK_IMPORTED_MODULE_0__wtballoon__["a" /* default */](Math.floor(Math.random() * 8), Math.floor(Math.random() * 256), 500, Math.floor(Math.random() * balloonSpeedRand) + balloonSpeedConst, WTGM);
      WTGM.objects.push(balloon);
    }
  },


  /**
   * decrease life by quantity
   *
   * @param {number} [quantity=1]
   */
  decreaseLife: function decreaseLife() {
    var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    WTGM.life -= quantity;
  },


  /**
   * toggle the easier baby mode
   *
   */
  toggleBaby: function toggleBaby() {
    if (WTGM.baby) {
      WTGM.baby = 0;
      WTGM.mode = 3;
    } else {
      WTGM.baby = 1;
      WTGM.mode = 50;
    }
    WTGM.endGame();
  }
};

// window.WTGM = WTGM;

WTGM.Draw = {
  clear: function clear() {
    WTGM.ctx.clearRect(0, 0, WTGM.WIDTH, WTGM.HEIGHT);
  },
  rect: function rect(x, y, w, h, col) {
    WTGM.ctx.fillStyle = col;
    WTGM.ctx.fillRect(x, y, w, h);
  },
  circle: function circle(x, y, r, col) {
    WTGM.ctx.fillStyle = col;
    WTGM.ctx.beginPath();
    WTGM.ctx.arc(x + 5, y + 5, r, 0, Math.PI * 2, true);
    WTGM.ctx.closePath();
    WTGM.ctx.fill();
  },
  text: function text(string, x, y, size, color) {
    WTGM.ctx.font = 'bold ' + size + 'px Monospace';
    WTGM.ctx.fillStyle = color;
    WTGM.ctx.fillText(string, x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WTGM);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* globals window AudioContext localStorage */
var sound = {
  aCtx: undefined,
  init: function init() {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.aCtx = new AudioContext();

    this.mainGain = this.aCtx.createGain();
    this.mainGain.gain.value = this.getVolume();
    this.mainGain.connect(this.aCtx.destination);
  },
  getVolume: function getVolume() {
    var volume = localStorage.getItem('sound');
    return volume !== null && volume >= 0 && volume <= 1 ? volume : 0.8;
  },
  setVolume: function setVolume(newVolume) {
    localStorage.setItem('sound', newVolume);
  },
  noiseBuffer: function noiseBuffer() {
    var bufferSize = this.aCtx.sampleRate;
    var buffer = this.aCtx.createBuffer(1, bufferSize, this.aCtx.sampleRate);
    var output = buffer.getChannelData(0);

    for (var i = 0; i < bufferSize; i += 1) {
      output[i] = Math.random() * 0.25 - 0.125;
    }

    return buffer;
  },
  playPlop: function playPlop() {
    if (!this.aCtx) {
      this.init();
    }

    this.mainGain.gain.value = this.getVolume();

    var time = sound.aCtx.currentTime;
    var noise = this.aCtx.createBufferSource();
    var noiseEnvelope = this.aCtx.createGain();

    noise.buffer = this.noiseBuffer();
    noise.connect(noiseEnvelope);
    noiseEnvelope.connect(this.mainGain);

    noiseEnvelope.gain.setValueAtTime(1, time);
    noiseEnvelope.gain.exponentialRampToValueAtTime(0.01, time + 0.2);
    noise.start(time);
    noise.stop(time + 0.2);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (sound);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(15);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResourceType; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ResourceLoader;
/* globals Image Audio */
// ResourceLoader class

var ResourceType = {
  IMAGE: 0
};

function ResourceLoader(onPartial, onComplete) {
  this.resources = [];
  this.resourcesLoaded = 0;

  if (onPartial !== undefined && typeof onPartial === 'function') {
    this.onPartial = onPartial;
  }

  if (onComplete !== undefined && typeof onComplete === 'function') {
    this.onComplete = onComplete;
  }
}

ResourceLoader.prototype.addResource = function addResource(filePath, fileType, resourceType) {
  if (resourceType === ResourceType.IMAGE) {
    var res = {
      filePath: filePath,
      fileType: fileType,
      resourceType: resourceType
    };

    this.resources.push(res);
  }
};

ResourceLoader.prototype.startPreloading = function startPreloading() {
  for (var i = 0, len = this.resources.length; i < len; i += 1) {
    // switch (this.resources[i].resourceType) {
    //   case ResourceType.IMAGE:
    var img = new Image();
    img.addEventListener('load', this.onResourceLoaded.bind(this), false);
    img.src = this.resources[i].filePath;
    // break;
    // case ResourceType.SOUND:
    //   var a = new Audio();

    //   // Only preload sound files that we can play.
    //   if (a.canPlayType(this.resources[i].fileType) === 'probably') {
    //     a.src = this.resources[i].filePath;
    //     a.type = this.resources[i].fileType;

    //     var rl = this;
    //     a.addEventListener('canplaythrough', function () {
    //       a.removeEventListener('canplaythrough', arguments.callee, false);
    //       rl.onResourceLoaded();
    //     }, false);
    //   } else {
    //     // Can't play the sound. Assume that the resource is loaded.
    //     this.onResourceLoaded();
    //   }

    //   break;
    // default:
    //   break;
    // }
  }
};

ResourceLoader.prototype.onResourceLoaded = function onResourceLoaded() {
  this.resourcesLoaded += 1;

  if (this.onPartial !== undefined) {
    this.onPartial();
  }

  if (this.resourcesLoaded === this.resources.length) {
    if (this.onComplete !== undefined) {
      this.onComplete();
    }
  }
};

ResourceLoader.prototype.isLoadComplete = function isLoadComplete() {
  if (this.resources.length === this.resourcesLoaded) {
    return true;
  }
  return false;
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wtgm__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sound__ = __webpack_require__(1);
/* unused harmony export addListenerMulti */
/* unused harmony export ready */
/* unused harmony export initUI */
/* globals document */



function addListenerMulti(el, s, fn) {
  if (el && s && fn) {
    s.split(' ').forEach(function (e) {
      return el.addEventListener(e, fn, false);
    });
  }
}

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

var initUI = function initUI() {
  addListenerMulti(document.querySelector('.startGame'), 'mousedown touchstart', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].setScore();
    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].startGame();
    document.querySelector('.ui').style.display = 'none';
    document.querySelector('canvas').style.display = '';
    document.querySelector('.openMenu').style.display = 'inline';
  });

  addListenerMulti(document.querySelector('.toBaby'), 'mousedown touchstart', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].toggleBaby();
    document.querySelector('.toBaby').style.display = 'none';
    document.querySelector('.toKids').style.display = '';
    // e.preventDefault();
    // document.location.href = 'baby.html';
  });

  addListenerMulti(document.querySelector('.toKids'), 'mousedown touchstart', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].toggleBaby();
    document.querySelector('.toBaby').style.display = '';
    document.querySelector('.toKids').style.display = 'none';
    // document.location.href = 'index.html';
  });

  addListenerMulti(document.querySelector('.openMenu'), 'mousedown touchstart', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].paused = 1;
    if (!__WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].hit) {
      __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].hit = 1; // keine minuspunkte
    }
    document.querySelector('.startGame').textContent = 'Restart';

    document.querySelector('.inGameOption').style.display = 'list-item';
    document.querySelector('.ui').classList.add('gameRunning');
    document.querySelector('.ui').style.display = '';
    document.querySelector('.openMenu').style.display = 'none';
  });

  addListenerMulti(document.querySelector('.resumeGame'), 'mousedown touchstart', function (e) {
    e.preventDefault();

    if (!__WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].hit) {
      __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].hit = 1; // keine minuspunkte
    }
    document.querySelector('.ui').style.display = 'none';
    document.querySelector('.openMenu').style.display = 'inline';

    __WEBPACK_IMPORTED_MODULE_0__wtgm__["a" /* default */].paused = 0;
  });
  // console.log(document.querySelector('.soundVolume').value);
  if (document.querySelector('.soundVolume')) {
    document.querySelector('.soundVolume').value = __WEBPACK_IMPORTED_MODULE_1__sound__["a" /* default */].getVolume();
  }
  addListenerMulti(document.querySelector('.soundVolume'), 'change', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_1__sound__["a" /* default */].setVolume(e.target.value);
  });
};

ready(initUI);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var appCacheIframe;

function hasSW() {
  return 'serviceWorker' in navigator &&
    // This is how I block Chrome 40 and detect Chrome 41, because first has
    // bugs with history.pustState and/or hashchange
    (window.fetch || 'imageRendering' in document.documentElement.style) &&
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
}

function install(options) {
  options || (options = {});

  
    if (hasSW()) {
      var registration = navigator.serviceWorker
        .register(
          "sw.js"
          
        );

      
        var handleUpdating = function(registration) {
          var sw = registration.installing || registration.waiting;
          var ignoreInstalling;
          var ignoreWaiting;

          // No SW or already handled
          if (!sw || sw.onstatechange) return;

          var stateChangeHandler;

          // Already has SW
          if (registration.active) {
            onUpdateStateChange();
            stateChangeHandler = onUpdateStateChange;
          } else {
            onInstallStateChange();
            stateChangeHandler = onInstallStateChange;
          }

          ignoreInstalling = true;
          if (registration.waiting) {
            ignoreWaiting = true;
          }

          sw.onstatechange = stateChangeHandler;

          function onUpdateStateChange() {
            switch (sw.state) {
              case 'redundant': {
                sendEvent('onUpdateFailed');
                sw.onstatechange = null;
              } break;

              case 'installing': {
                if (!ignoreInstalling) {
                  sendEvent('onUpdating');
                }
              } break;

              case 'installed': {
                if (!ignoreWaiting) {
                  sendEvent('onUpdateReady');
                }
              } break;

              case 'activated': {
                sendEvent('onUpdated');
                sw.onstatechange = null;
              } break;
            }
          }

          function onInstallStateChange() {
            switch (sw.state) {
              case 'redundant': {
                // Failed to install, ignore
                sw.onstatechange = null;
              } break;

              case 'installing': {
                // Installing, ignore
              } break;

              case 'installed': {
                // Installed, wait activation
              } break;

              case 'activated': {
                sendEvent('onInstalled');
                sw.onstatechange = null;
              } break;
            }
          }
        };

        var sendEvent = function(event) {
          if (typeof options[event] === 'function') {
            options[event]({
              source: 'ServiceWorker'
            });
          }
        };

        registration.then(function(reg) {
          // WTF no reg?
          if (!reg) return;

          // Installed but Shift-Reloaded (page is not controller by SW),
          // update might be ready at this point (more than one tab opened).
          // Anyway, if page is hard-reloaded, then it probably already have latest version
          // but it's not controlled by SW yet. Applying update will claim this page
          // to be controlled by SW. Maybe set flag to not reload it?
          // if (!navigator.serviceWorker.controller) return;

          handleUpdating(reg);
          reg.onupdatefound = function() {
            handleUpdating(reg);
          };
        }).catch(function(err) {
          sendEvent('onError');
          return Promise.reject(err);
        });
      

      return;
    }
  

  
    if (window.applicationCache) {
      var directory = "appcache/";
      var name = "manifest";

      var doLoad = function() {
        var page = directory + name + '.html';
        var iframe = document.createElement('iframe');

        

        iframe.src = page;
        iframe.style.display = 'none';

        appCacheIframe = iframe;
        document.body.appendChild(iframe);
      };

      if (document.readyState === 'complete') {
        setTimeout(doLoad);
      } else {
        window.addEventListener('load', doLoad);
      }

      return;
    }
  
}

function applyUpdate(callback, errback) {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration || !registration.waiting) {
          errback && errback();
          return;
        }

        registration.waiting.postMessage({
          action: 'skipWaiting'
        });

        callback && callback();
      });

      return;
    }
  

  
}

function update() {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration) return;
        return registration.update();
      });
    }
  

  
    if (appCacheIframe) {
      try {
        appCacheIframe.contentWindow.applicationCache.update();
      } catch (e) {}
    }
  
}



exports.install = install;
exports.applyUpdate = applyUpdate;
exports.update = update;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./ml.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./ml.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./ui.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./ui.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wtgm__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resourceLoader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_ml_css__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_ml_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_ml_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_ui_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_ui_css__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateHandler", function() { return updateHandler; });
/* harmony export (immutable) */ __webpack_exports__["default"] = preloadResources;
/* global window document */








/* eslint-disable no-console */
var updateHandler = {
  onUpdating: function onUpdating() {
    console.log('SW Event:', 'onUpdating');
  },
  onUpdateReady: function onUpdateReady() {
    console.log('SW Event:', 'onUpdateReady');
    // Tells to new SW to take control immediately
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__["applyUpdate"]();
  },
  onUpdated: function onUpdated() {
    console.log('SW Event:', 'onUpdated');
    // Reload the webpage to load into the new version
    window.location.reload();
  },
  onUpdateFailed: function onUpdateFailed() {
    console.log('SW Event:', 'onUpdateFailed');
  }
};
/* eslint-enable no-console */
__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__["install"](updateHandler);
// OfflinePluginRuntime.install({
//   onUpdating: () => {
//     console.log('SW Event:', 'onUpdating');
//   },
//   onUpdateReady: () => {
//     console.log('SW Event:', 'onUpdateReady');
//     // Tells to new SW to take control immediately
//     OfflinePluginRuntime.applyUpdate();
//   },
//   onUpdated: () => {
//     console.log('SW Event:', 'onUpdated');
//     // Reload the webpage to load into the new version
//     window.location.reload();
//   },
//   onUpdateFailed: () => {
//     console.log('SW Event:', 'onUpdateFailed');
//   },
// });

// import './img/sprite.png';
// import './img/back.png';

function preloadResources(canvas, callback) {
  // const c = canvas.getContext('2d');
  function printProgressBar() {}

  var rl = new __WEBPACK_IMPORTED_MODULE_2__resourceLoader__["a" /* default */](printProgressBar, callback);

  rl.addResource('./img/sprite.png', null, __WEBPACK_IMPORTED_MODULE_2__resourceLoader__["b" /* ResourceType */].IMAGE);
  rl.addResource('./img/back.png', null, __WEBPACK_IMPORTED_MODULE_2__resourceLoader__["b" /* ResourceType */].IMAGE);

  rl.startPreloading();

  printProgressBar();
}

window.addEventListener('load', __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].init.bind(null, preloadResources));
window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].resize);
window.addEventListener('keydown', __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].handleKeyDown);

// window.onblur = function () {
//   // console.log('lostBlur');
// };
// window.focusout = function () {
//   // console.log('lostFocus');
// };


function touchEndHandler() {
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].handleTouchEnd();
}

function touchHandler(event) {
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].handleTouch(event.pageX, event.pageY);
}

window.addEventListener('mousedown', function (e) {
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].touching = 1;
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].touchStart = new Date().getTime();
  touchHandler(e);
});
document.querySelector('canvas').addEventListener('mousemove', function (e) {
  touchHandler(e);
});
window.addEventListener('mouseup', function (e) {
  touchEndHandler(e);
});

window.addEventListener('touchstart', function (e) {
  e.preventDefault();
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].touching = 1;
  __WEBPACK_IMPORTED_MODULE_1__wtgm__["a" /* default */].touchStart = new Date().getTime();
  // touchHandler(e.touches[0]);
  Array.from(e.touches).map(function (touch) {
    return touchHandler(touch);
  });
}, false);
window.addEventListener('touchmove', function (e) {
  e.preventDefault();
  Array.from(e.touches).map(function (touch) {
    return touchHandler(touch);
  });
}, false);

window.addEventListener('touchend', function (e) {
  // Verhindert Scrollen/Unnötiges Bewegen nach oben oder unten
  e.preventDefault();
  touchEndHandler();
}, false);

// const pointer = {
//   DOWN: 'mousedown',
//   UP: 'mouseup',
//   MOVE: 'mousemove',
// };
// let int = 0;
// let movedOnce = 0;
// let dir;
// document.querySelector('#moveUp').addEventListener(pointer.DOWN, (e) => {
//   // e.preventDefault();
//   if (int == 0) {
//     dir = 0;
//     movedOnce = 0;
//     int = self.setInterval(() => {
//       movedOnce = 1;
//       WTGM.move(dir);
//     }, 100);
//   }
// });
// document.querySelector('#moveDown').addEventListener(pointer.DOWN, (e) => {
//   // e.preventDefault();
//   if (int == 0) {
//     dir = 1;
//     movedOnce = 0;
//     int = self.setInterval(() => {
//       movedOnce = 1;
//       WTGM.move(dir);
//     }, 100);
//   }
// });
// document.querySelector('#moveLeft').addEventListener(pointer.DOWN, (e) => {
//   // e.preventDefault();
//   if (int == 0) {
//     dir = 2;
//     movedOnce = 0;
//     int = self.setInterval(() => {
//       movedOnce = 1;
//       WTGM.move(dir);
//     }, 100);
//   }
// });
// document.querySelector('#moveRight').addEventListener(pointer.DOWN, (e) => {
//   // e.preventDefault();
//   if (int == 0) {
//     dir = 3;
//     movedOnce = 0;
//     int = self.setInterval(() => {
//       movedOnce = 1;
//       WTGM.move(dir);
//     }, 100);
//   }
// });
// document.querySelector('#movement li').addEventListener(pointer.UP, (e) => {
//   if (int != 0) {
//     window.clearInterval(int);
//     if (!movedOnce) {
//       WTGM.move(dir);
//     }
//     int = 0;
//   }
// });
// document.querySelector('#movement').addEventListener(pointer.UP, (e) => {
//   e.preventDefault();
// });

/* Device Motion */
/* TODO: Check ob DeviceOrientation besser geeignet ( http://www.html5rocks.com/en/tutorials/device/orientation/ ) */

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* globals window */
// http://paulirish.com/2011/requestanimationframe-for-smart-animating
// shim layer with setTimeout fallback

var requestAnimFrame = function shimmedRequestAnimFrame() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function timeoutAnimation(callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (requestAnimFrame);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sound__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = wtBalloon;



function wtBalloon(balloonNumber, x, y, speed, WTGM) {
  this.balloonNumber = balloonNumber;
  this.verticalOffset = 0;
  this.horizontalOffset = 0;
  this.width = 64;
  this.height = 64;
  this.x = x;
  this.y = y;
  this.speed = speed;
  this.waveSize = Math.random() * 20 + 4;
  this.origX = this.x;
  this.remove = 0;
  this.pauseFrame = 0;
  switch (this.balloonNumber) {
    case 0:
      this.verticalOffset = 0;
      this.horizontalOffset = 0;
      this.width = 64;
      this.height = 64;
      break;
    case 1:
      this.verticalOffset = 178;
      this.horizontalOffset = 0;
      this.width = 32;
      this.height = 64;
      break;
    case 2:
      this.verticalOffset = 356;
      this.horizontalOffset = 0;
      this.width = 32;
      this.height = 64;
      break;
    case 3:
      this.verticalOffset = 534;
      this.horizontalOffset = 0;
      this.width = 32;
      this.height = 64;
      break;
    case 4:
      this.verticalOffset = 712;
      this.horizontalOffset = 0;
      this.width = 64;
      this.height = 64;
      break;
    case 5:
      this.verticalOffset = 890;
      this.horizontalOffset = 0;
      this.width = 32;
      this.height = 64;
      break;
    case 6:
      this.verticalOffset = 1068;
      this.horizontalOffset = 0;
      this.width = 64;
      this.height = 64;
      break;
    default:
      this.verticalOffset = 1246;
      this.horizontalOffset = 0;
      this.width = 64;
      this.height = 64;
      break;
  }
  this.lastUpdate = new Date().getTime();
  this.score = 30000 * this.speed / this.width;
  this.slowFps = 0;

  this.draw = function draw(context) {
    context.drawImage(WTGM.tex, this.horizontalOffset, this.verticalOffset, this.width * 2, this.height * 2, this.x, this.y, this.width, this.height);
  };

  this.update = function update() {
    if (!WTGM.paused) {
      var time = new Date().getTime();
      var lastFrameTime = time - this.lastUpdate;

      if (lastFrameTime < 90) {
        // || this.slowFps){ //entspricht 11 FPS
        this.y -= (time - this.lastUpdate) * speed / 10;
        this.x = this.waveSize * Math.sin(time * 0.002) + this.origX;
        this.lastUpdate = time;
      } else {
        this.pauseFrame += 1;
      }
      if (this.pauseFrame > 5) {
        this.lastUpdate = time;
        this.pauseFrame = 0;
      }

      if (this.y < -this.width) {
        this.remove = 1;
        WTGM.decreaseLife(1);
      }
    }
  };

  this.isInside = function isInside(xP, yP) {
    if (this.remove) {
      return false;
    }
    if (xP > this.x && xP < this.x + this.width && yP > this.y && yP < this.y + this.height) {
      __WEBPACK_IMPORTED_MODULE_0__sound__["a" /* default */].playPlop();
      return true;
    }
    return false;
  };
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WtMessage;
function WtMessage(message, x, y, color, WTGM) {
  return {
    message: message,
    color: color,
    x: x,
    y: y,
    remove: 0,
    insertTime: new Date().getTime(),
    draw: function draw() {
      WTGM.Draw.text(this.message, this.x, this.y, 24, this.color);
    },
    update: function update() {
      var time = new Date().getTime();
      if (time - this.insertTime > 700) {
        this.remove = 1;
      }
    },
    isInside: function isInside() {
      return false;
    }
  };
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "blockquote,body,canvas,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,input,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}body{background:#000;width:100%;height:100%;margin:0 auto}html{//min-width:480px;//min-height:320px}body{margin:0;padding:0;overflow:hidden;font-family:Tahoma,Geneva,sans-serif;font-size:12px;color:#222;background:##F7F0F0}.hidden{display:none}canvas{display:block;margin:0 auto;background:#fff;width:320px;height:480px}", ""]);

// exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".ui{display:block;position:absolute;left:0;top:0;width:100%;height:100%;background-color:#aeaeae;color:#000;list-style:none}.ui.gameRunning{opacity:.9;filter:alpha(opacity=90)}.ui li{margin:20px auto;padding:0;display:block;width:85%}.ui li a,.ui li span{font-size:2em;text-align:center;padding:20px;display:block;width:100%;background-color:#33aeae;text-decoration:none;border-radius:60px;color:#000;cursor:pointer}.openMenu,.ui .inGameOption{display:none}.openMenu{padding:10px;text-decoration:none;position:absolute;border-radius:400px;right:10px;top:10px;background:#efefef}.soundVolume{padding-top:5rem}input[type=range]{-webkit-appearance:none;width:100%;margin:8.35px 0;background:transparent}input[type=range]:focus{outline:none}input[type=range]::-webkit-slider-runnable-track{width:100%;height:13.3px;cursor:pointer;background:#33aeae;border-radius:25px;border:2.3px solid transparent}input[type=range]::-webkit-slider-thumb{border:5px solid #000;height:30px;width:30px;border-radius:12px;background:#000;cursor:pointer;-webkit-appearance:none;margin-top:-10.65px}input[type=range]:focus::-webkit-slider-runnable-track{background:#42c8c8}input[type=range]::-moz-range-track{width:100%;height:13.3px;cursor:pointer;background:#33aeae;border-radius:25px;border:2.3px solid transparent}input[type=range]::-moz-range-thumb{border:5px solid #000;height:30px;width:30px;border-radius:12px;background:#000;cursor:pointer}input[type=range]::-ms-track{width:100%;height:13.3px;cursor:pointer;background:transparent;border-color:transparent;color:transparent}input[type=range]::-ms-fill-lower{background:#2a8e8e;border:2.3px solid transparent;border-radius:50px}input[type=range]::-ms-fill-upper{background:#33aeae;border:2.3px solid transparent;border-radius:50px}input[type=range]::-ms-thumb{border:5px solid #000;height:30px;width:30px;border-radius:12px;background:#000;cursor:pointer;height:13.3px}input[type=range]:focus::-ms-fill-lower{background:#33aeae}input[type=range]:focus::-ms-fill-upper{background:#42c8c8}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.c26f970179971e95ebd9.js